import React, { useState } from "react";

const PromoCapabilities = () => {
  const [active, setActive] = useState(null);

  const handleTouch = (item) => {
    setActive(item === active ? null : item);
  };

  const tags = [
    "React",
    "Angular",
    "AI",
    "Full Stack Web Apps",
    "SAP ERP",
    "Supply Chain",
    "SAP MM",
    "Master Data",
    "Automation",
    "Smart Notifications",
    "Data Analytics",
    "JavaScript",
    "Node.js",
    "HTML5",
    "CSS Design",
    "SAP EWM",
    "Bootstrap",
  ];

  return (
    <section className="hero-pattern-dots bg-white dark:bg-slate-900 text-textDark dark:text-textLight px-4 sm:px-6 py-12 sm:py-16 text-center transition-colors duration-300">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-[DM Sans] font-bold mb-4 sm:mb-6">
          Delivering AI-Powered Business Solutions
        </h2>
        <p className="font-[Inter] text-base sm:text-lg mb-6 sm:mb-8 text-gray-700 dark:text-gray-300">
          Through Full Stack Development, ERP Solutions, and Process Automation.
        </p>
        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 max-w-3xl mx-auto">
          {tags.map((item, idx) => (
            <button
              key={item}
              type="button"
              onClick={() => handleTouch(item)}
              onTouchStart={() => handleTouch(item)}
              className={`
                px-4 py-2 text-sm rounded-full font-medium transition w-full sm:w-auto text-center cursor-pointer opacity-0 animate-pop-in
                ${active === item
                  ? "bg-blue-700 dark:bg-blue-400 text-white"
                  : "bg-gray-100 dark:bg-slate-800 text-black dark:text-gray-200 hover:bg-blue-700 hover:text-white dark:hover:bg-blue-500 dark:hover:text-white"
                }
              `}
              style={{
                animationDelay: `${idx * 100}ms`,
                animationFillMode: "forwards",
                animationTimingFunction: "ease-out",
              }}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromoCapabilities;
